import { MotionContainer } from '@bakerweb/components';
import { Container, Typography } from '@mui/material';
import { m } from 'framer-motion';

export const PermissionDenied = () => (
  <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
    <m.div>
      <Typography variant="h3" paragraph>
        Permission Denied
      </Typography>
    </m.div>

    <m.div>
      <Typography sx={{ color: 'text.secondary' }}>You do not have permission to access this page</Typography>
    </m.div>
  </Container>
);
